import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

export default function PageLayout({ eyebrow, title, subtitle, children, hero }) {
  return (
    <div className="bg-[#050505] min-h-screen text-white" data-testid={`page-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <Navbar />
      <div className="pt-32 px-4 sm:px-12 max-w-[1200px] mx-auto pb-20">
        {hero && (
          <div className="relative h-64 sm:h-80 rounded-2xl overflow-hidden mb-12 border border-white/5">
            <img src={hero} alt="" className="w-full h-full object-cover opacity-50" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/60 to-transparent" />
            <div className="absolute inset-0 flex flex-col justify-end p-8 sm:p-12">
              {eyebrow && <span className="text-xs font-bold text-[#E50914] uppercase tracking-[0.3em] mb-3">{eyebrow}</span>}
              <h1 className="text-4xl sm:text-6xl font-black tracking-tighter" style={{ fontFamily: "Outfit" }}>{title}</h1>
              {subtitle && <p className="text-lg text-[#bbb] mt-2 max-w-2xl">{subtitle}</p>}
            </div>
          </div>
        )}
        {!hero && (
          <header className="mb-12 animate-fade-up">
            {eyebrow && <span className="text-xs font-bold text-[#E50914] uppercase tracking-[0.3em]">{eyebrow}</span>}
            <h1 className="text-4xl sm:text-6xl font-black tracking-tighter mt-3" style={{ fontFamily: "Outfit" }}>{title}</h1>
            {subtitle && <p className="text-lg text-[#bbb] mt-3 max-w-2xl">{subtitle}</p>}
          </header>
        )}
        <div className="prose-djino max-w-none">{children}</div>
      </div>
      <Footer />
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section className="mb-10">
      {title && <h2 className="text-2xl sm:text-3xl font-bold mb-4 tracking-tight" style={{ fontFamily: "Outfit" }}>{title}</h2>}
      <div className="text-[#cdcdcd] leading-relaxed space-y-4 text-base">{children}</div>
    </section>
  );
}
